export default __webpack_public_path__ + "static/nexgen-core-programming-7f4f0cead254adb38513fd5a30e26295.webp";